import { brand } from "../../../../../../config/theme";
/**
 * Colores por tipo de geocerca (para el color del shape en el mapa)
 */
export const typeColors: Record<string, string> = {
  warehouse: "#2563eb", // azul
  restrictedArea: "#ef4444", // rojo
  customer: "#0891b2", // cyan
  route: "#a21caf", // morado
  maintenance: "#f59e42", // naranja/ámbar
  authorizedStop: brand.primary, // verde
  truck_yard: "#14b8a6", // teal — geocercas de patios de maniobra
  default: "#6b7280", // gris
};

/**
 * Obtiene las clases de color para un tipo de geocerca
 */
export const getTypeColor = (type: string): string => {
  switch (type) {
    case "warehouse":
      return "text-blue-500 bg-blue-500/10";
    case "restrictedArea":
      return "text-red-500 bg-red-500/10";
    case "customer":
      return "text-cyan-600 bg-cyan-100";
    case "route":
      return "text-purple-500 bg-purple-500/10";
    case "maintenance":
      return "text-amber-500 bg-amber-500/10";
    case "authorizedStop":
      return "text-primary-500 bg-primary-500/10";
    case "truck_yard":
      return "text-teal-500 bg-teal-500/10";
    default:
      return "text-gray-500 bg-gray-500/10";
  }
};

/**
 * Obtiene el texto del tipo de geocerca
 */
export const getTypeText = (type: string): string => {
  switch (type) {
    case "warehouse":
      return "Almacén";
    case "restrictedArea":
      return "Zona Restringida";
    case "customer":
      return "Cliente";
    case "route":
      return "Ruta";
    case "maintenance":
      return "Mantenimiento";
    case "authorizedStop":
      return "Parada Autorizada";
    case "truck_yard":
      return "Patio de Maniobras";
    default:
      return "Otro";
  }
};

/**
 * Obtiene el icono del tipo de geocerca
 */
export const getTypeIcon = (type: string): string => {
  switch (type) {
    case "warehouse":
      return "ri-building-line";
    case "restrictedArea":
      return "ri-forbid-line";
    case "customer":
      return "ri-user-star-line";
    case "route":
      return "ri-route-line";
    case "maintenance":
      return "ri-tools-line";
    case "authorizedStop":
      return "ri-parking-box-line";
    case "truck_yard":
      return "ri-truck-line";
    default:
      return "ri-map-pin-line";
  }
};

/**
 * Obtiene las clases de color para un estado basado en el nombre del status
 */
export const getStatusColorByName = (statusName: string): string => {
  const normalizedName = statusName?.toLowerCase() || "";
  if (normalizedName.includes("activ")) {
    return "text-primary-500 bg-primary-500/10";
  }
  if (normalizedName.includes("inactiv")) {
    return "text-red-500 bg-red-500/10";
  }
  if (normalizedName.includes("manten") || normalizedName.includes("maintenance")) {
    return "text-orange-600 bg-orange-100";
  }
  if (normalizedName.includes("ruta") || normalizedName.includes("route")) {
    return "text-blue-600 bg-blue-100";
  }
  if (normalizedName.includes("paus")) {
    return "text-yellow-600 bg-yellow-100";
  }
  return "text-gray-500 bg-gray-500/10";
};

/**
 * Obtiene las clases de color para un estado (legacy - por compatibilidad)
 */
export const getStatusColor = (status: string): string => {
  return getStatusColorByName(status);
};

/**
 * Obtiene el texto del estado (legacy - por compatibilidad)
 */
export const getStatusText = (status: string): string => {
  switch (status) {
    case "active":
    case "ACTIVE":
      return "Activa";
    case "inactive":
    case "INACTIVE":
      return "Inactiva";
    case "maintenance":
    case "MAINTENANCE":
      return "Mantenimiento";
    case "onRoute":
    case "ON_ROUTE":
      return "En Ruta";
    case "paused":
    case "PAUSED":
      return "Pausada";
    default:
      return status || "Desconocido";
  }
};

/**
 * Obtiene el texto de la forma geométrica
 */
export const getShapeText = (shape: string): string => {
  switch (shape) {
    case "circular":
      return "Circular";
    case "linear":
      return "Lineal";
    case "polygonal":
      return "Polígono";
    default:
      return "Corredor";
  }
};
